const D = Date

export const now = D.now

export function isoNow(): string {
  return (new D).toISOString()
}

export default D